export default "__VITE_ASSET__CALgwBNN__"